function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}"), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  width: 512,
  height: 512
})));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "1");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M301.62,90.3V70.53a45.54,45.54,0,0,0-91.08,0V90.3a45.54,45.54,0,0,0,91.08,0m-79.08,0V70.53a33.54,33.54,0,0,1,67.08,0V90.3a33.54,33.54,0,0,1-67.08,0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M182.67,259.43H329.49a6,6,0,0,0,6-6V239.65H436a6,6,0,0,0,6-6V194.71a45,45,0,0,0-42.11-44.86c-3.2-.23-4.84,1.79-6.18,3.42a27.52,27.52,0,0,1-43.44-1.06,6,6,0,0,0-5-2.43,44.33,44.33,0,0,0-22.07,6.44A50.45,50.45,0,0,0,288,138.76c-3.1-.13-4.66,1.75-6.18,3.6a32.3,32.3,0,0,1-51-1.25,6,6,0,0,0-5-2.43A50.23,50.23,0,0,0,191,153.88c-.76.78-1.48,1.58-2.18,2.39a44.63,44.63,0,0,0-20.45-6.42c-3.19-.23-4.85,1.79-6.18,3.42a27.52,27.52,0,0,1-43.44-1.06,6,6,0,0,0-5-2.43A45,45,0,0,0,70,194.71v38.94a6,6,0,0,0,6,6H176.67v13.78a6,6,0,0,0,6,6M342.73,162a39.55,39.55,0,0,0,55.81,3.53,40,40,0,0,0,3.39-3.38A33,33,0,0,1,430,194.71v32.94H335.49V189.16a50.14,50.14,0,0,0-5.54-23A32.18,32.18,0,0,1,342.73,162M223.3,150.86a44.31,44.31,0,0,0,66.93.16,38.54,38.54,0,0,1,33.26,38.14v58.27H188.67V189.16a38.76,38.76,0,0,1,34.63-38.3M82,227.65V194.71A33.17,33.17,0,0,1,111.25,162a39.5,39.5,0,0,0,59.19.15,32.73,32.73,0,0,1,11.71,4.13,50.41,50.41,0,0,0-5.48,22.91v38.49Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M412.35,108.18V90.87a40.61,40.61,0,0,0-81.22,0v17.31a40.61,40.61,0,0,0,81.22,0m-69.22,0V90.87a28.61,28.61,0,1,1,57.22,0h0v17.31a28.61,28.61,0,1,1-57.22,0Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M180.87,108.18V90.87a40.61,40.61,0,0,0-81.22,0v17.31a40.61,40.61,0,0,0,81.22,0m-69.22,0V90.87a28.61,28.61,0,1,1,57.22,0h0v17.31a28.61,28.61,0,1,1-57.22,0Z"
}));

var SvgSignup = function SvgSignup(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    viewBox: "0 0 512 293",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSignup, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/signup.3a9e4e01.svg";
export { ForwardRef as ReactComponent };